module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Roman-e35c05f258ebeb0868161a0e540ac117.svg";